namespace advisorop.components.common {
    
    class UserInfoNavController {

        $router;
        adminMode: boolean;
        impersonationMode: boolean = true;
        
        user: domains.identity.IUser = {};

        userFullName: string = "";
        userRoles: string = "";
        pictureUrl: string; // = "profile_small.png";
        showSparkline: boolean = false;
        lastLogin: Date;


        public section;
        public sparklineTitle;
        public sparklineData;
        public sparklineSum;

        static $inject = ["identityService"];
        constructor(public identityService: services.IdentityService) {
            
        }

        logout(): void {
            this.identityService.logout();
        }

        endImpersonation(): void {
            if (window.confirm(`End Impersonation of current user and get back to your real user account ?`)) {
                // authenticate servicer as advisor 
                this.identityService.endImpersonation()
                    .then(response => {
                        // clear localstorage
                        localStorage.clear();
                        // redirect page to advisor dashboard
                        window.location.href = "/";
                    }).catch(err => toastr.error(`Error ${err.status} ${err.data}`))
            }
        }
        

        $onInit(): void {
           // console.log("user-info init...");
            this.identityService.getUserPromise().then(response => {
                this.user = response;

                this.userFullName = this.user.firstName + " " + this.user.lastName;

                this.userRoles = this.user.role;

                this.pictureUrl = this.user.pictureUrl; // ? this.user.pictureUrl : "profile.jpg";

                this.showSparkline = this.user && this.user.systemLoginType > 0;

                this.lastLogin = this.user.lastLogin;

                //console.log(this.user, "Show sparkline:", this.showSparkline, this.sparklineSum, this.sparklineData, this.sparklineTitle);
            }); 
        }

        $routerOnActivate(next, previous) {
        }
    }



    class UserInfoNav implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public transclude;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<",
                section: "@",
                sparklineTitle: "@",
                sparklineData: "<",
                sparklineSum: "@"
            };
            this.transclude = {
                adminmode: "?adminMode",
                impersonationmode: "?impersonationMode"
            };
            this.controller = UserInfoNavController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/shared/common/user-info-nav.html";
        }
    }
    angular.module(Constants.APP).component("userInfoNav", new UserInfoNav());


}